module.exports = __webpack_public_path__ + "img/NIS_Governance.cf27a72b.svg";